import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'sbnb-price-callout',
  template: `
    <div class="flex items-baseline price">
      <span class="prefix" *ngIf="prefix">{{ prefix }}</span>
      <span class="currency" [ngClass]="{ small: size === 'small' }">{{ currency | currencyCode }}</span>
      <span [ngClass]="{ 'large-price': size === 'large', 'small-price': size === 'small' }">{{ amount }}</span>
      <span class="per" [ngClass]="{ small: size === 'small' }">
        <span>/{{ per }}</span>
        <span *ngIf="perAddendum" class="per-addendum">{{ perAddendum }}</span>
      </span>
    </div>
  `,
  styles: [
    `
      @import 'variables';

      .price {
        font-family: 'Cera Headings', 'Helvetica Neue', sans-serif;
        color: $grape-darker;
      }

      .large-price {
        font-size: 2.5rem;
        line-height: 2rem;
      }

      .small-price {
        font-size: 1.5rem;
      }

      .per {
        display: flex;
        flex-direction: column;
        gap: 4px;
        font-size: 1rem;

        &.small {
          font-size: 0.85rem;
        }
      }

      .per-addendum {
        font-family: 'Cera', 'Helvetica Neue', sans-serif;
      }

      .currency {
        font-size: 1rem;
        align-self: flex-start;

        &.small {
          font-size: 0.85rem;
        }
      }

      .prefix {
        font-size: 1.25rem;
        align-self: flex-start;
        margin: 1% 6px 0 0;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PriceCalloutComponent implements OnInit {
  @Input() currency: string;
  @Input() amount: string;
  @Input() per: string;
  @Input() size: 'small' | 'large' = 'large';
  @Input() perAddendum: string = null;
  @Input() prefix: string = null;
  constructor() { }

  ngOnInit(): void { }
}
